export class NewsCategoryCustomRouteParam {
  prefix?: string;
  titleTranslateKey?: string;

  constructor(prefix?: string, titleTranslateKey?: string) {
    this.prefix = prefix;
    this.titleTranslateKey = titleTranslateKey;
  }
}
